<template>
  <van-popup
    v-model:show="showPopup"
    position="bottom"
    :style="{ height: '60%' }"
    teleport="body"
    :closeable="true"
    @close="close"
    class="name-card-list"
  >
    <div class="top-action">
      <span>交易卡</span>

      <!-- <span class="font-gray" @click="close()">X</span> -->
    </div>

    <template v-if="!tradeCardList.length">
      <van-empty description="暂无交易卡，请联系云雀客服协助开通功能" />
    </template>

    <template v-if="tradeCardList.length">
      <div class="list-container">
        <div class="name-card" v-for="item in tradeCardList" :key="item.id">
          <div class="left">
            <div class="avatar" style="border-radius: 10%;">
              <img referrerpolicy="no-referrer" :src="item.image" alt="" />
            </div>
            <div class="text">
              <div>{{ item.title }}</div>
              <div class="font-gray">{{ item.sub_title }}</div>
            </div>
          </div>

          <div class="right">
            <van-button
              color="rgb(25, 137, 250)"
              style="padding: 0 20px"
              round
              plain
              @click="send(item)"
              >发送</van-button
            >
          </div>
        </div>

        <div style="margin: 20px 0; color: #aaaaaa" class="text-center">
          - 如需更多，可前往小红书专业号后台添加 -
        </div>
      </div>
    </template>
  </van-popup>
</template>

<script>
import { Popup, Empty, Button } from "vant";
import { defineComponent } from "vue";
import { getTradeCardList } from "@/api/common";
import CommetFactory from "@/api/CommetFactory";
import { mapGetters } from "vuex";

export default defineComponent({
  props: {
    appid: String,
  },

  emits: ["close"],

  components: {
    [Popup.name]: Popup,
    [Empty.name]: Empty,
    [Button.name]: Button,
  },

  computed: {
    ...mapGetters({
      currentVisitor: "currentVisitor",
    }),
  },

  data() {
    return {
      showPopup: true,
      tradeCardList: [],
    };
  },

  beforeMount() {
    getTradeCardList({
      appid: this.appid,
      pagesize: 100,
    }).subscribe((res) => {
      console.log(res);

      this.tradeCardList = res;
    });
  },

  methods: {
    close() {
      this.$emit("close");
    },

    send(nameCard) {
      const Commet = CommetFactory(this.$store);

      const cmicrotime = Date.now();
      const msg = {
        platform: "redbook",
        cmd: "worker",
        body: JSON.stringify({
          ...nameCard,
          format: "trade_card",
        }),
        uid: this.currentVisitor.uid,
        cmicrotime: cmicrotime,
      };

      try {
        Commet.send(msg);
      } catch (error) {
        console.log(error);
      }

      this.close();
    },
  },
});
</script>

<style scoped>
.list-container {
  height: calc(100% - 43px);
  overflow-y: auto;
  padding: 0 16px;
}

.font-gray {
  color: #666;
}
.text-center {
  text-align: center;
}

.top-action {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  align-items: center;

  padding: 10px 16px;
}

.name-card {
  height: 80px;
  background-color: white;
  margin-top: 10px;
  border-radius: 5px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
}

.name-card .left {
    display: flex;
    align-items: center;

    .avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }
}

.name-card .left div.text div {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

button.van-button {
  transform: scale(0.9);
}
</style>

<style>
.van-popup.name-card-list {
  background-color: #fafafa !important;
  font-size: 14px;
}
</style>
